import { socket } from "@pages/Layout/Layout";
import { updateNotificationCounts } from "@store/actions/notification.action";
import { useEffect } from "react";
import { useDispatch } from "react-redux";

const useNotification = () => {
  const dispatch = useDispatch();

  //Socket Listener
  useEffect(() => {
    // Remove any existing listeners for this event
    socket?.off("newUnreadNotificationCount");
    socket?.off("newUnreadInterviewNotificationCount");

    //Notification unread count
    socket?.on("newUnreadNotificationCount", (unreadNoitification) => {
      console.log("New Message", unreadNoitification);
      dispatch(
        updateNotificationCounts({
          notification: unreadNoitification,
        })
      );
    });

    //Interview unread count
    socket?.on(
      "newUnreadInterviewNotificationCount",
      (unreadInterviewNotificaiton) => {
        console.log("New Message", unreadInterviewNotificaiton);
        dispatch(
          updateNotificationCounts({ meeting: unreadInterviewNotificaiton })
        );
      }
    );

    // Cleanup on component unmount
    return () => {
      socket?.off("newUnreadNotificationCount");
      socket?.off("newUnreadInterviewNotificationCount");
    };
  }, []);
};

export default useNotification;
